import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, updateProfile, onAuthStateChanged, signInWithPopup, sendEmailVerification, GoogleAuthProvider } from "firebase/auth";
import { auth } from "../../firebase";

function Signup() {
  const navigate = useNavigate();
  const [values, setValues] = useState({
    name: "",
    email: "",
    mobile: "",
    pass: "",
  });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [verificationSent, setVerificationSent] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // Define showPassword state variable

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && user.emailVerified) {
        // If the user is already logged in and their email is verified, redirect to the next page
        navigate("../Vehicletype");
      }
    });

    // Clean up the subscription when the component unmounts
    return () => unsubscribe();
  }, []);

  const handleGoogleSignup = async () => {
    try {
      setLoading1(true);
      const provider = new GoogleAuthProvider();
      const res = await signInWithPopup(auth, provider);
      const user = res.user;
      if (user && user.emailVerified) {
        navigate("/Vehicletype");
      } else {
        setVerificationSent(true);
      }
    } catch (err) {
      setErrorMsg(err.message);
    } finally {
      setLoading1(false);
    }
  };

  const handleSubmission = async () => {
    try {
      setLoading(true);

      if (!values.name ||!values.email ||!values.mobile ||!values.pass) {
        setErrorMsg("Fill all fields");
        return;
      }

      // Additional input validation (you can customize these conditions)
      if (!validateEmail(values.email)) {
        setErrorMsg("Invalid email address");
        return;
      }

      if (!validateMobile(values.mobile)) {
        setErrorMsg("Invalid mobile number");
        return;
      }

      // Validate the password
      validatePassword();

      // Check if there's any error message from password validation
      if (errorMsg) {
        return;
      }

      const res = await createUserWithEmailAndPassword(auth, values.email, values.pass);
      const user = res.user;

      // Send email verification
      await sendEmailVerification(auth.currentUser);

      setVerificationSent(true);

      const userType = "regular";
      const userData = {
        email: values.email,
        mobile: values.mobile,
        password: values.pass,
        usertype: userType,
      };

      await updateProfile(user, { displayName: values.name });
      
      // Don't navigate automatically, wait for email verification
    } catch (err) {
      setErrorMsg(err.message);
    } finally {
      setLoading(false);
    }
  };

  const validateEmail = (email) => {
    // Simple email validation (you can use a more comprehensive library)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile) => {
    // Simple mobile number validation (you can customize based on your requirements)
    return /^\d{10}$/.test(mobile);
  };

  // Function to validate the password
  const validatePassword = () => {
    const password = values.pass;
    // Regular expressions for each rule
    const hasUppercase = /[A-Z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasDigit = /\d/.test(password);

    // Check if the password meets all criteria
    if (password.length < 8) {
      setErrorMsg("Password must be at least 8 characters long");
    } else if (!hasUppercase) {
      setErrorMsg("Password must contain at least one uppercase letter");
    } else if (!hasSpecialChar) {
      setErrorMsg("Password must contain at least one special character");
    } else if (!hasDigit) {
      setErrorMsg("Password must contain at least one digit");
    } else {
      setErrorMsg(""); // Clear error message if password is valid
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "90vh" }}>
      <div style={{ width: "500px", padding: "20px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: "#fff" }}>
        <h1 style={{ textAlign: "center", marginBottom: "20px" }}>Signup</h1>
        {verificationSent ? (
          <p style={{ textAlign: "center", color: "green" }}>Verification email sent to {values.email}. Click the link in the email to verify your email address.</p>
        ) : (
          <>
            <input
              type="text"
              placeholder="&#xf0e0; Enter your name"
              value={values.name}
              onChange={(event) => setValues((prev) => ({ ...prev, name: event.target.value }))}
              style={{
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "100%",
                fontFamily: "Arial, FontAwesome", // Ensure FontAwesome is used for the icon
              }}
            />
            <input
              type="email"
              placeholder="&#xf0e0; Enter email address"
              value={values.email}
              onChange={(event) => setValues((prev) => ({ ...prev, email: event.target.value }))}
              style={{
                padding: "10px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "100%",
                fontFamily: "Arial, FontAwesome", // Ensure FontAwesome is used for the icon
              }}
            />

            <div className="input-group">
              <input
                type="tel"
                placeholder="&#xf10b; Enter mobile number"
                value={values.mobile}
                onChange={(event) => setValues((prev) => ({ ...prev, mobile: event.target.value }))}
                style={{
                  padding: "10px",
                  fontSize: "16px",
                  border: "1px solid #ccc",
                  borderRadius: "5px",
                  width: "100%",
                  fontFamily: "Arial, FontAwesome", // Ensure FontAwesome is used for the icon
                }}
              />
            </div>

            <div style={{ position: "relative" }}>
  <input
    type={showPassword ? "text" : "password"}
    placeholder="&#xf13e; Enter password"
    value={values.pass}
    onChange={(event) => setValues((prev) => ({ ...prev, pass: event.target.value }))}
    style={{
      padding: "10px",
      fontSize: "16px",
      border: "1px solid #ccc",
      borderRadius: "5px",
      width: "100%",
      fontFamily: "Arial, FontAwesome", // Ensure FontAwesome is used for the icon
    }}
    onBlur={validatePassword}
  />
  <button
    type="button"
    onClick={() => setShowPassword((prev) => !prev)}
    style={{
      width: "40px",
      height: "100%",
      border: "none",
      backgroundColor: "transparent",
      position: "absolute",
      right: "0",
      top: "0",
      color:"#000",
      cursor: "pointer",
    }}
  >
    {showPassword ? "Hide" : "Show"}
  </button>
</div>

            

            <div style={{ marginTop: "20px" }}>
              <p style={{ textAlign: "center", marginBottom: "10px" }}>
                <b style={{ color: "red" }}>{errorMsg}</b>
              </p>
              <button
                style={{ width: "100%", padding: "10px", marginBottom: "10px" }}
                onClick={handleSubmission}
                disabled={loading}
              >
                {loading ? "Signing up..." : "Signup"}
              </button>
              <p style={{ textAlign: "center", marginTop: "10px" }}>or</p>
              <button
                style={{ width: "100%", padding: "10px", marginBottom: "10px", backgroundColor: "#fff", color: "#000", border: "none", borderRadius: "5px", cursor: "pointer" }}
                onClick={handleGoogleSignup}
                disabled={loading1}
              >
                <img src="https://image.similarpng.com/very-thumbnail/2020/12/Illustration-of-Google-icon-on-transparent-background-PNG.png" alt="Google Icon" style={{ marginRight: "10px", width: "20px", height: "20px" }} />
                {loading1 ? "Signing up with Google..." : "Signup with Google"}
              </button>
              <p style={{ textAlign: "center", marginTop: "10px" }}>
                Already have an account?{" "}
                <span>
                  <Link to="/login">Login</Link>
                </span>
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Signup;
